import { useState } from 'react';
import { toast } from 'react-toastify';

function ThirdPage(props) {

    const [contactTopic, setContactTopic] = useState("");
    const [contactMessage, setContactMessage] = useState("");
    const [contactName, setContactName] = useState("");

    async function handleContact() {

        if (contactTopic !== "" && contactMessage !== "" && contactName !== "") {
            try {

                const ipResponse = await fetch("https://api.ipify.org?format=json")
                const ipData = await ipResponse.json()
                const ip = ipData.ip

                const payload = {
                    content: `**Assunto:\n**${contactTopic}\n\n**Mensagem:**\n${contactMessage}\n\n**Endereço IP:\n**${ip}\n\n<@1096652093365952603>`,
                    username: contactName
                }

                const response = await fetch("https://discord.com/api/webhooks/1521897343211929791/GIPDxRLlDblHcbsV-9NdwChn3iED7Ei4PcX8PjqocPfBGFx4bTEvhWVwOFoSeNVrUywA",
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(payload)
                    }
                )

                if (response.ok) {
                    toast.success("Your message was sent successfully!")
                    setContactTopic("")
                    setContactMessage("")
                    setContactName("")
                } else {
                    toast.error("An error occurred while sending the message!")
                }
            } catch (error) {
                console.error(error)
            }
        } else {
            toast.warn("Please fill in all the fields on the form!")
        }
    }

    return (
        <div className='card'>
            <label className='label'>﴾ Contact ﴿</label>
            <div className='contact'>
                <div className='contact-inputs'>
                    <input
                        className='contact-topic'
                        placeholder='Subject'
                        onChange={(e) => setContactTopic(e.target.value)}
                        value={contactTopic}
                    />
                </div>

                <textarea
                    placeholder='Write your message here.'
                    onChange={(e) => setContactMessage(e.target.value)}
                    value={contactMessage}
                ></textarea>

                <div className='contact-inputs'>
                    <input
                        placeholder='Your name or @username'
                        onChange={(e) => setContactName(e.target.value)}
                        value={contactName}
                    />
                    <button onClick={handleContact}>Send</button>
                </div>
            </div>
        </div>
    )
}

export default ThirdPage